var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg bg-success text-center py-2 text-white border-0 font-weight-bold",staticStyle:{"cursor":"pointer"},attrs:{"type":"button"},on:{"click":_vm.openWhatsApp}},[_c('i',{staticClass:"fab fa-whatsapp pr-1"}),_vm._v(" Contactar por WhatsApp\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }